import { ModalContext } from '@/context/ModalContext'
import { ModalType } from '@/constants/common.contant'
import { useContext } from 'react'

export const useModal = (modalId: ModalType) => {
  const context = useContext(ModalContext)
  if (!context) throw new Error('useModal must be used within a ModalProvider')

  const { modals, openModal, closeModal } = context
  return {
    isModalOpen: modals[modalId] || false,
    openModal: () => openModal(modalId),
    closeModal: () => closeModal(modalId),
  }
}
